<template>
    <div class="relative">
        <AppButton
            @click="isDropdownVisible = !isDropdownVisible"
            :aria-expanded="isDropdownVisible"
            :class="{
                '!bg-gray-tier-6': isDropdownVisible,
            }"
            icon="arrow-up"
            text="Share"
            icon-size="large"
            icon-class="rotate-45"
        >
        </AppButton>
        <div
            v-click-outside="closeDropdown"
            v-if="isDropdownVisible"
            class="
                absolute 
                p-5 right-0 
                rounded-md 
                top-full 
                translate-x-[212px] 
                translate-y-[15px] 
                w-[calc(var(--app-detail-aside-width)_-_4rem)] 
                z-10
                dark:bg-v2-gray-50
                bg-v2-white
                border border-gray-225 dark:border-gray-850 shadow-black/20 shadow-xl
            "
        >
            <ul class="space-y-2">
                <ShareByEmail />
                <CopyButton />
                <DownloadPdfButton />
            </ul>
        </div>
    </div>
</template>

<script setup>
import {ref} from "vue";
import { ShareByEmail, CopyButton, DownloadPdfButton } from "@/Components/Modules/ProductDetail/TopButtons/"
import { AppButton } from "@/Components";

const isDropdownVisible = ref(false);

function closeDropdown () {
    isDropdownVisible.value = false;
}
</script>
